import type { components } from '../../api/schema.gen.ts';
import { apiFetch } from '../../api/http.ts';

/**
 * Aliased from the generated OpenAPI types, like every other feature's client — a
 * server-side rename shows up here as a type error rather than as a wrong render.
 */
type Schemas = components['schemas'];

export type PushCapability = Schemas['PushCapabilityResponse'];

export const pushKeys = {
  capability: ['push', 'capability'] as const,
};

/**
 * What this deployment and this device can do.
 *
 * Takes the browser's current endpoint because "are notifications on?" is a question about
 * the phone in your hand, not about the account — permission and the subscription both
 * belong to the browser, so somebody with it enabled on a laptop must still see it as off
 * on their phone.
 */
export function getPushCapability(endpoint: string | null): Promise<PushCapability> {
  const query = endpoint === null ? '' : `?endpoint=${encodeURIComponent(endpoint)}`;

  return apiFetch<PushCapability>(`/api/notifications/capability${query}`);
}

/**
 * Registers this device. Idempotent on the endpoint, so it is safe — and intended — to
 * call again whenever the browser hands out a subscription the server has not seen.
 */
export function savePushSubscription(subscription: {
  endpoint: string;
  p256dh: string;
  auth: string;
}): Promise<void> {
  return apiFetch<void>('/api/notifications/subscription', {
    method: 'PUT',
    json: subscription,
  });
}

export function deletePushSubscription(endpoint: string): Promise<void> {
  return apiFetch<void>(
    `/api/notifications/subscription?endpoint=${encodeURIComponent(endpoint)}`,
    { method: 'DELETE' },
  );
}
